<template>
  <div class="card mb-5 mb-xxl-8">
    <div v-show="isReady" class="card mb-5 mb-xl-10" id="kt_profile_details_view">
      <!--begin::Card header-->
      <div class="card">
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <div class="card-title">
            <h3 class="card-label">{{ $t('promotion.list') }}</h3>
          </div>
          <div class="card-toolbar">
            <a href="#" v-if="can('promotion_create')" @click.prevent="router.push({ name: 'shop-promotion-create', params: { id: route.params.id } })" class="btn btn-sm btn-primary">{{ $t('promotion.create') }}</a>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <table class="table align-middle table-row-bordered fs-6 gy-3 " id="kt_datatable_promotion">
              <thead>
              <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                <th class="min-w-100px">{{ $t('promotion.image')}}</th>
                <th class="min-w-100px">{{ $t('promotion.title')}}</th>
                <th class="min-w-100px">{{ $t('promotion.applyTo')}}</th>
                <th class="min-w-100px">{{ $t('promotion.startDate')}}</th>
                <th class="min-w-100px">{{ $t('promotion.endDate')}}</th>
                <th class="min-w-100px">{{ $t('promotion.online')}}</th>
                <th class="min-w-100px">{{ $t('action') }}</th>
              </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="card mb-5 mb-xl-10" v-show="!isReady">
      <Loader text="Loading..." />
    </div>

  </div>
</template>

<script setup>

import AppSubHeader from "@/views/Promotion/Partials/AppSubHeader.vue";
import Loader from "@/components/Loader.vue";
import { BASE_URL, BASE_IMAGE_URL } from "@/services/api";
import {useStore} from "vuex";
import {computed, onMounted, reactive, ref, nextTick, watch, onBeforeUnmount} from "vue";
import { useRouter, useRoute } from "vue-router"
import {useHasAbility} from "@/composables/hasAbility";
import Ls from "@/services/ls";
import {formatDate, createFormData} from "@/mixins/Helper.vue";
import {formatDateWithSeparator} from "@/mixins/Helper";

const router = useRouter()
const store = useStore()
const { can } = useHasAbility()
const route = useRoute()

const locale = computed(() => i18n.global.locale)

const getDatatableLocaleUrl = computed(() => {
  return locale.value === 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json"
})

const getApplies = computed(() => store.getters['promotion/getAppliesEnum'])


const title = ref("breadcrumbs.promotion.title")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.store.dashboard',
    path: '/admin/dashboard'
  },
  {
    name: 'breadcrumbs.promotion.list',
    path: '/admin/promotions'
  }
])
const isReady = ref(false)
const table = ref()
const formDeleteData = ref({
  id: null,
  row: null
})


onMounted(() => {
  isReady.value = false
  store.dispatch('permission/loadPermissions').then(() => {
    fetchDatas()
  })
  store.dispatch('promotion/loadAppliesEnum')

  isReady.value = true
})

watch(() => locale.value, () => {
  nextTick(() => {
    fetchDatas()
  })
})

// Vue Router réutilise ce composant quand on passe de la fiche d'une boutique
// à une autre (même route, seul :id change) — sans ce watcher, la datatable
// garde les promotions de l'ancienne boutique consultée.
watch(() => route.params.id, (newId, oldId) => {
  if (newId && newId !== oldId) {
    fetchDatas()
  }
})

onBeforeUnmount(() => {
  $(document).off(".shopPromotions")
})

function fetchDatas() {
  const AUTH_TOKEN = Ls.get('auth.token')

  table.value = $("#kt_datatable_promotion").DataTable({
    destroy: true,
    responsive: !0,
    searchDelay: 500,
    processing: !0,
    serverSide: !0,
    pageLength: Ls.get('pageLength') ?? 10,
    lengthMenu: [5, 10, 25, 50, 75, 100 ],
    order: [[ 1, 'asc']],
    ajax: {
      url: BASE_URL + '/shop/' + route.params.id + '/get/promotions/datatable',

      type: "GET",
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
      }
    },
    columns: [
      // Mobile : titre, statut et date de fin restent visibles avant l'image
      { data: "image", responsivePriority: 4 },
      { data: "title", responsivePriority: 1 },
      { data: "apply", responsivePriority: 5 },
      { data: "startDate", responsivePriority: 6 },
      { data: "endDate", responsivePriority: 3 },
      { data: "online", responsivePriority: 2 },
      { data: "Actions", responsivePriority: -1 }
    ],
    columnDefs: [
      {
        targets: -7,
        orderable:false,
        searchable:false,
        className: "dt-center clickable" ,
        render: function (t, a, e, l) {
          return '<img id="'+ e.id +'" src="'+ t +'"  style="width: 50px; height: 50px;" />';
        },
      },

      {
        targets: -6,
        className: "dt-center clickable" ,
        render:  (t, a, e, l) => {
          return '<span data-id="'+ e.id +'">' + t + "</span>";
        },
      },

      {
        targets: -5,
        className: "dt-center clickable text-center" ,
        render: function (t, a, e, l) {
          const apply = displayApplyName(t)
          return '<span data-id="'+ e.id +'" class="'+ apply.className +'">' + apply.name + "</span>";
        },
      },

      {
        targets: -4,
        className: "dt-center clickable" ,
        render: function (t, a, e, l) {
          return '<span data-id="'+ e.id +'">' + formatDate(t) + "</span>";
        },
      },

      {
        targets: -3,
        className: "dt-center clickable" ,
        render: function (t, a, e, l) {
          return '<span data-id="'+ e.id +'">' + formatDate(t) + "</span>";
        },
      },

      {
        targets: -2,
        orderable:false,
        searchable:false,
        render:  function(t, a, e, l) {
          let render=""
          if(t && can('promotion_update')){
            render += '<span class="form-check form-switch form-check-custom form-check-solid visible btn_change_online" data-id="'+ e.id +'"><label><input type="checkbox" checked id="'+ e.id +'"  class="form-check-input online h-20px w-30px" data-id="'+ e.id +'" /><span></span></label></span>';
          }
          if(!t && can('promotion_update')){
            render += '<span class="form-check form-switch form-check-custom form-check-solid visible btn_change_online" data-id="'+ e.id +'"><label> <input type="checkbox" data-id="'+ e.id +'"  id="'+ e.id +'" class="form-check-input h-20px w-30px"/><span></span></label></span>';
          }
          return render
        },
      },

      {
        width: "20%",
        targets: -1,
        "className": "dt-center",
        title: "Actions",
        orderable: !1,
        render: function(t, a, e, l) {
          let render=""
          if(can('promotion_update')  ){
            render+='<a href="javascript:;"  data-id="'+ e.id +'" class="btn btn-sm btn-clean btn-icon edit_btn" title="'+ i18n.global.t('button.edit') +'"><i  data-id="'+ e.id +'"  class="la la-edit fs-2"></i></a>'
          }
          if(can('promotion_delete')  ){
            render += '<a href="javascript:;" data-row="'+ l.row +'" data-id="'+ e.id +'" class="btn btn-sm btn-clean btn-icon delete_btn" title="'+ i18n.global.t('button.delete') +'"><i data-row="'+ l.row +'" data-id="'+ e.id +'" class="la la-trash fs-2"></i></a>'
          }
          return render
        },
      },
    ],
    language: {
      url: getDatatableLocaleUrl.value,
    }
  });

  // Écouteurs posés sur le document : sans nettoyage ils survivent à l'écran (et se cumulent à
  // chaque rechargement du tableau). La liste des promotions d'une boutique et la liste
  // générale partagent le même id de tableau : celui de l'autre écran se déclenchait aussi.
  $(document).off(".shopPromotions")
  $(document).on("click.shopPromotions", "#kt_datatable_promotion .btn_change_online", (e) => {
    const id = e.target.getAttribute('data-id');
    updatePromotionStatus(id)
  });

  $(document).on("click.shopPromotions", "#kt_datatable_promotion .edit_btn", (e) => {
    let id = e.target.getAttribute('data-id')
    router.push({name: 'shop-promotion-detail', params: { id: route.params.id, promotionId: id} })
  });

  $(document).on("click.shopPromotions", "#kt_datatable_promotion .delete_btn", (e) => {
    formDeleteData.value.id = e.target.getAttribute('data-id')
    const id = e.target.getAttribute('data-id')
    formDeleteData.value.row = e.target.getAttribute('data-row')
    deletePromotion(id)
  });
}

function displayApplyName(value) {
  let apply = getApplies.value.find(ap => ap.value === value)
  let name=''
  let className=''
  if(apply){
    name = apply[locale.value];
    className = apply.className
  }
  return { name, className }
}

async function updatePromotionStatus(id) {
  try {
    await store.dispatch('promotion/updatePromotionStatus', id)
    window.toastr['success'](i18n.global.t('notification.promotion.update_status_success'))
  }catch (e) {
    window.toastr['success'](i18n.global.t('notification.promotion.update_status_error'))
  }
}

async function deletePromotion(id) {
  Swal.fire({
    title: i18n.global.t('swal.promotion_deleting'),
    text: i18n.global.t('swal.text'),
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: i18n.global.t('swal.yes'),
    cancelButtonText: i18n.global.t('swal.no'),
  }).then( async (result) => {
    if (result.value) {
      try {
        await store.dispatch('promotion/deletePromotion', id)
        table.value.ajax.reload()
        window.toastr['success'](i18n.global.t('notification.promotion.delete_success'))
      }catch (e) {
      }
    }
  });
}

</script>

<style scoped>
.clear-icon {
  position: absolute;
  top: 50%;
  right: 0.5rem; /* Ajustez la distance de l'icône par rapport au côté droit du champ */
  transform: translateY(-50%);
  cursor: pointer;
  color: #ccc; /* Couleur de l'icône (gris clair) */
}

.clear-icon:hover {
  color: #333; /* Couleur de l'icône au survol (noir) */
}
</style>